import React from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import PageTitles from "./PageTitles";


const TurnosLicenciasMenuContinuar = () => {
    const navigate = useNavigate();

    const clickHandler = (e) =>{
        navigate("/turnoslicencias",{state: {id: e.split("|")[1], name: e.split("|")[0]}});
        
    }

    
    return (
        <>
       <div class="container text-center indexContent" >
            {/*<div class="row">
                <div class="col">
                    <h1 class="titleIndicator">
                    <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/turnosdocumentacionmenu")}}/> Licencias</h1>
                </div>
    </div>*/}
    <PageTitles texto="Turnos" subtexto="Licencias" icono="./icon_header_turnos.svg" retorno="/turnoslicenciasmenu"/>
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                <button className="buttonInvertedClip" onClick={()=> clickHandler(localStorage.getItem("Licencias-Sel"))}>Continuar</button>
                </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
               &nbsp;
                </div>
            </div>
          
            <div className="row">
                <div className="col miniText">
                    <b>Documentación a presentar:</b>
                </div>
            </div>
            <div className="row">
                <div className="col miniMiniText">
              { localStorage.getItem("Licencias-Sel").includes("Original")?
              <div style={{textAlign:"justify",marginTop:"5px;"}}>
                Este turno es para Licencias por primera vez o licencias vencidas por más de 90 días. 
                <ul style={{listStyle:"circle"}}>
                <li style={{lineHeight:"15px",marginTop:"5px"}}> DNI vigente (domicilio en Pilar), original y copia.</li>
                <li style={{lineHeight:"15px",marginTop:"5px"}}>Grupo y Factor sanguíneo. </li>
                <li style={{lineHeight:"15px",marginTop:"5px"}}> Certificado del Curso Virtual de Seguridad Vial, deberá traerlo impreso. Ingresá en https://curso.seguridadvial.gob.ar </li>
                <li style={{lineHeight:"15px",marginTop:"5px"}}> Cédula Verde/Azul del vehículo con el que rendís el examen práctico, original y copia.</li>
                <li style={{lineHeight:"15px",marginTop:"5px"}}> Si sos menor de 18 años lleva autorización certificada ante Escribano Público o Juez de Paz, original y copia. </li>
                <li style={{lineHeight:"15px",marginTop:"5px"}}> Además, preséntate con el vehículo acorde a la categoría que solicitas y con un acompañante con licencia vigente habilitante para la categoría que conduce</li>
                </ul>
              <br/>
              
              IMPORTANTE: el turno obtenido y el trámite a realizar deben coincidir, ya que el día de atención será corroborado. Si el trámite requerido era otro, deberás sacar un nuevo turno. (Sin excepción)
              </div>:""}
              {localStorage.getItem("Licencias-Sel").includes("rofesion")?
               <div style={{textAlign:"justify",marginTop:"5px;"}}>
               Este turno es para LICENCIAS PROFESIONAL PRIMERA VEZ 
               <ul style={{listStyle:"circle"}}>
               <li style={{lineHeight:"15px",marginTop:"5px"}}> DNI vigente (domicilio en Pilar), original y copia.</li>
               <li style={{lineHeight:"15px",marginTop:"5px"}}>Licencia de conducir, original y copia. </li>
               <li style={{lineHeight:"15px",marginTop:"5px"}}> Certificado de antecedentes penales, original y copia. </li>
               <li style={{lineHeight:"15px",marginTop:"5px"}}> Cédula Verde/Azul del vehículo con el que rendís el examen práctico, original y copia.</li>
               <li style={{lineHeight:"15px",marginTop:"5px"}}> Certificado de Legalidad, SÓLO si la licencia fue emitida en otra jurisdicción y no se encuentra registrada en el Sistema Provincial de Licencias. </li>
               <li style={{lineHeight:"15px",marginTop:"5px"}}> Además, preséntate con el vehículo acorde a la categoría que solicitas y con un acompañante con licencia vigente habilitante para la categoría que conduce</li>
               </ul>
             <br/>
             
             En caso de querer renovar la licencia profesional, corresponde al trámite RENOVACIÓN.

             <br/>
             IMPORTANTE: el turno obtenido y el trámite a realizar deben coincidir, ya que el día de atención será corroborado. Si el trámite requerido era otro, deberás sacar un nuevo turno. (Sin excepción)
             <br/>
             Para más información ingresa en: https://pilar.gov.ar/tramites/licencia-de-conducir/ 
             </div>
              :""}
               {localStorage.getItem("Licencias-Sel").includes("mpliaci")?
               <div style={{textAlign:"justify",marginTop:"5px;"}}>
               Este turno es para ampliar las categorías de la licencia vigente. 
               <ul style={{listStyle:"circle"}}>
               <li style={{lineHeight:"15px",marginTop:"5px"}}> DNI vigente (domicilio en Pilar), original y copia.</li>
               <li style={{lineHeight:"15px",marginTop:"5px"}}>Licencia de conducir, original y copia. </li>
               <li style={{lineHeight:"15px",marginTop:"5px"}}> Certificado del Curso Virtual de Seguridad Vial, deberá traerlo impreso.
ingresá en https://curso.seguridadvial.gob.ar 
</li>
               <li style={{lineHeight:"15px",marginTop:"5px"}}> Cédula Verde/Azul del vehículo con el que rendís el examen práctico, original y copia.</li>
               <li style={{lineHeight:"15px",marginTop:"5px"}}> Certificado de Legalidad, SÓLO si la licencia fue emitida en otra jurisdicción y no se encuentra registrada en el Sistema Provincial de Licencias. </li>
               <li style={{lineHeight:"15px",marginTop:"5px"}}> Además, preséntate con el vehículo acorde a la categoría que solicitas y con un acompañante con licencia vigente habilitante para la categoría que conduce</li>
               </ul>
             <br/>
             
             IMPORTANTE: el turno obtenido y el trámite a realizar deben coincidir, ya que el día de atención será corroborado. Si el trámite requerido era otro, deberás sacar un nuevo turno. (Sin excepción)
             <br/>
             Para más información ingresa en: https://pilar.gov.ar/tramites/licencia-de-conducir/ 
             </div>
              :""}
                 {localStorage.getItem("Licencias-Sel").includes("enovaci")?
               <div style={{textAlign:"justify",marginTop:"5px;"}}>
               SI el turno es para Licencias *particular* renovación.
               <ul style={{listStyle:"circle"}}>
               <li style={{lineHeight:"15px",marginTop:"5px"}}> DNI vigente (domicilio en Pilar), original y copia.</li>
               <li style={{lineHeight:"15px",marginTop:"5px"}}>Licencia de conducir, original y copia. </li>
             
               </ul>
               La renovación de una licencia vencida por más de 90 días debe cumplir los mismos requisitos de documentación que una licencia original, incluido el Certificado del Curso Virtual de Seguridad Vial, que tendrás que llevar impreso. Ingresá en: https://curso.seguridadvial.gob.ar
               <br/>
               El turno para las licencias vencidas más de 90 días debe ser para *trámite original*
               <br/>
               Las personas *mayores de 70 años* podrán asistir *SIN TURNO* de 08:00 a 10:00 am. 
             <br/>
             SI el turno es para Licencias *particular* renovación.
               <ul style={{listStyle:"circle"}}>
               <li style={{lineHeight:"15px",marginTop:"5px"}}> DNI vigente (domicilio en Pilar), original y copia.</li>
               <li style={{lineHeight:"15px",marginTop:"5px"}}>Licencia de conducir, original y copia. </li>
             
               </ul>
               Profesionales que NO tengan la licencia vencida al momento de renovar quedan exentos del examen práctico. Para renovar, tenés que presentar el trámite de antecedentes penales             <br/>

             <br/>
             IMPORTANTE: el turno obtenido y el trámite a realizar deben coincidir, ya que el día de atención será corroborado. Si el trámite requerido era otro, deberás sacar un nuevo turno. (Sin excepción)
             <br/>
             </div>
              :""}
             
              
                </div>
            </div>
            
            
           
       </div>
        
        </>

    );
}

export default TurnosLicenciasMenuContinuar;